<template>
    		<!-- Banner Section -->
		<section class="banner-section banner-eight">
			<div class="container">
				<div class="home-banner">
					<div class="row align-items-center">
						<div class="col-lg-7">
							<div class="section-search section-search-eight aos" data-aos="fade-up">
								<h1> <span>Change Your World,</span> Set <br> Your Tech Career in Motion With
									<span>Listee</span>

								</h1>
								<p class="paragraph">Finding a Job Shouldn’t Be a Full-time Job. 1,50,334 Jobs Listed Here! Your Dream Job is Waiting.</p>
								<div class="search-box">
									<form action="listing-grid-sidebar" class="d-flex">
										<div class="search-input line">
											<div class="form-group">
												<div class="group-img">
													<input type="text" class="form-control"
														placeholder="Type your skill or other">
												</div>
											</div>
										</div>
										<div class="search-input">
											<div class="form-group">
												<div class="group-img">
													<input type="text" class="form-control"
														placeholder="Place you want?">
												</div>
											</div>
										</div>
										<div class="search-btn">
											<button class="btn btn-primary" type="submit"> <i class="fa fa-search"
													aria-hidden="true"></i> Search</button>
										</div>
									</form>
								</div>
								<div class="popular-search">
									<span>Popular Searches: </span>

									<a href="javascript:void(0);">WordPress</a>

									<a href="javascript:void(0);">HTML5</a>

									<a href="javascript:void(0);">UI UX Designer</a>

									<a href="javascript:void(0);">Marketing</a>
								</div>
							</div>
						</div>
						<div class="col-lg-5">

						</div>
						<div class="banner-main-img">
							<div class="banner-imgs">
								<img src="@/assets/img/banner/main-banner-7.png" class="img-fluid" alt="bannerimage">
							</div>
							<div class="banner-imgs-2">
								<img src="@/assets/img/banner/circle-11.png" class="img-fluid" alt="bannerimage">
							</div>
							<div class="main-banner-left">
								<img src="@/assets/img/banner-left-bottom.png" class="img-fluid" alt="bannerimage">
							</div>
							<div class="main-banner-left-shadow">
								<img src="@/assets/img/banner-left-bottom-shadow.png" class="img-fluid"
									alt="bannerimage">
							</div>
							<div class="main-banner-right">
								<img src="@/assets/img/banner-right-bottom.png" class="img-fluid"
									alt="bannerimage">
							</div>
							<div class="main-banner-right-shadow">
								<img src="@/assets/img/banner-right-bottom-shadow.png" class="img-fluid"
									alt="bannerimage">
							</div>
							<div class="banner-topic ">
								<div class="topic-content one shape-1">
									<div class="topic-img">
										<img src="@/assets/img/content-img.png" class="img-fluid"
											alt="bannerimage">
									</div>
									<div class="topic-details ">
										<h4>Finance</h4>
										<p>3000+ Jobs Available</p>
									</div>
								</div>
								<div class="topic-content two shape-2">
									<div class="topic-img">
										<img src="@/assets/img/content-img.png" class="img-fluid"
											alt="bannerimage">
									</div>
									<div class="topic-details">
										<h4>Teacher</h4>
										<p>2000+ Jobs Available</p>
									</div>
								</div>
								<div class="topic-content three shape-2">
									<div class="topic-details">
										<h4>Marketing & Sales</h4>
										<p>1500+ Jobs Available</p>
									</div>
									<div class="topic-img">
										<img src="@/assets/img/content-img.png" class="img-fluid"
											alt="bannerimage">
									</div>
								</div>
								<div class="topic-content four shape-1">
									<div class="topic-details">
										<h4>App Development</h4>
										<p>5000+ Jobs Available</p>
									</div>
									<div class="topic-img">
										<img src="@/assets/img/content-img.png" class="img-fluid"
											alt="bannerimage">
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="banner-main-bg">
				<div class="bannerleftop">
					<img src="@/assets/img/banner-top-bg.png" class="img-fluid" alt="arrow">
				</div>
				<div class="bannerleftbottom">
					<img src="@/assets/img/banner-center-bg.png" class="img-fluid" alt="arrow">
				</div>
				<div class="bannermiddle">
					<img src="@/assets/img/banner-middle.png" class="img-fluid" alt="arrow">
				</div>
			</div>
		</section>
		<!-- /Banner Section -->

		<!-- Category Section -->
		<section class="category-section category-eight ">
			<div class="container">
				<div class="section-heading heading-eight">
					<div class="row align-items-center">
						<div class="col-md-12 aos aos-init aos-animate text-center" data-aos="fade-up">
							<h2>Browse Jobs By Category</h2>
							<p>Lorem Ipsum is simply dummy text of the printing</p>
						</div>
					</div>
				</div>
				<div class="category-details">
					<div class="row">
						<div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 aos d-flex" data-aos="fade-up">
							<div class="category-inner flex-fill">
								<div class="category-img-two">
									<img src="@/assets/img/icons/icons-1.png" class="img-fluid" alt="no-img">
								</div>
								<div class="category-content">
									<h4>UI/UX Design</h4>
									<p>43 Jobs Available</p>
								</div>
							</div>
						</div>
						<div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 aos d-flex" data-aos="fade-up">
							<div class="category-inner flex-fill">
								<div class="category-img-two">
									<img src="@/assets/img/icons/icons-2.png" class="img-fluid" alt="no-img">
								</div>
								<div class="category-content">
									<h4>Digital Marketing</h4>
									<p>43 Jobs Available</p>
								</div>
							</div>
						</div>
						<div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 aos d-flex" data-aos="fade-up">
							<div class="category-inner flex-fill">
								<div class="category-img-two">
									<img src="@/assets/img/icons/icons-3.png" class="img-fluid" alt="no-img">
								</div>
								<div class="category-content">
									<h4>Content Writing </h4>
									<p>43 Jobs Available</p>
								</div>
							</div>
						</div>
						<div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 aos d-flex" data-aos="fade-up">
							<div class="category-inner flex-fill">
								<div class="category-img-two">
									<img src="@/assets/img/icons/icons-4.png" class="img-fluid" alt="no-img">
								</div>
								<div class="category-content">
									<h4>HR Management</h4>
									<p>43 Jobs Available</p>
								</div>
							</div>
						</div>
						<div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 aos d-flex" data-aos="fade-up">
							<div class="category-inner flex-fill">
								<div class="category-img-two">
									<img src="@/assets/img/icons/icons-5.png" class="img-fluid" alt="no-img">
								</div>
								<div class="category-content">
									<h4>Account Finance </h4>
									<p>43 Jobs Available</p>
								</div>
							</div>
						</div>
						<div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 aos d-flex" data-aos="fade-up">
							<div class="category-inner flex-fill">
								<div class="category-img-two">
									<img src="@/assets/img/icons/icons-6.png" class="img-fluid" alt="no-img">
								</div>
								<div class="category-content">
									<h4>Sales</h4>
									<p>43 Jobs Available</p>
								</div>
							</div>
						</div>
						<div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 aos d-flex" data-aos="fade-up">
							<div class="category-inner flex-fill">
								<div class="category-img-two">
									<img src="@/assets/img/icons/icons-7.png" class="img-fluid" alt="no-img">
								</div>
								<div class="category-content">
									<h4>Project Management</h4>
									<p>43 Jobs Available</p>
								</div>
							</div>
						</div>
						<div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 aos d-flex" data-aos="fade-up">
							<div class="category-inner flex-fill">
								<div class="category-img-two">
									<img src="@/assets/img/icons/icons-8.png" class="img-fluid" alt="no-img">
								</div>
								<div class="category-content">
									<h4>Customer Support Care</h4>
									<p>43 Jobs Available</p>
								</div>
							</div>
						</div>
						<div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 aos d-flex" data-aos="fade-up">
							<div class="category-inner flex-fill">
								<div class="category-img-two">
									<img src="@/assets/img/icons/icons-9.png" class="img-fluid" alt="no-img">
								</div>
								<div class="category-content">
									<h4>Business & Consulting</h4>
									<p>43 Jobs Available</p>
								</div>
							</div>
						</div>
						<div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 aos d-flex" data-aos="fade-up">
							<div class="category-inner flex-fill">
								<div class="category-img-two">
									<img src="@/assets/img/icons/icons-10.png" class="img-fluid" alt="no-img">
								</div>
								<div class="category-content">
									<h4>Web Developer</h4>
									<p>43 Jobs Available</p>
								</div>
							</div>
						</div>
						<div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 aos d-flex" data-aos="fade-up">
							<div class="category-inner flex-fill">
								<div class="category-img-two">
									<img src="@/assets/img/icons/icons-11.png" class="img-fluid" alt="no-img">
								</div>
								<div class="category-content">
									<h4>Construction</h4>
									<p>43 Jobs Available</p>
								</div>
							</div>
						</div>
						<div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 aos d-flex" data-aos="fade-up">
							<div class="category-inner flex-fill">
								<div class="category-img-two">
									<img src="@/assets/img/icons/icons-12.png" class="img-fluid" alt="no-img">
								</div>
								<div class="category-content">
									<h4>Health and Care</h4>
									<p>43 Jobs Available</p>
								</div>
							</div>
						</div>
					</div>
					<div class="align-items-center justify-content-center d-flex"><router-link to="listing-grid-sidebar"
							class="category-btn">View All Category</router-link>
					</div>
				</div>
			</div>
		</section>
		<!-- /Category Section -->
    </template>